const internalApiQueryWrapper = async ({ url, args }) => {
  const internalUrl = new URL(url, document.location)
  Object.keys(args).forEach((key) => internalUrl.searchParams.append(key, args[key]))

  const data = await fetch(internalUrl)
  return await data.json()
}

export default internalApiQueryWrapper
